import { Component, Input, OnInit,  SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BysBelge, BysBelgeDetay } from 'libs/bys/src/lib/models/bys.models';
import { DxButtonModule, DxFileUploaderModule, DxFormModule, DxLoadPanelModule } from 'devextreme-angular';
import { CtGenLookupComponent, CtlGenKisiComponent, CtlGenKontrolComponent, CtlIkaPersonelComponent,
   DkGlobalUserSettingsService, PhoneComponent, UtilsService } from '@dabnet-kamu/libs/ui';
import { FormLabelMode, LabelLocation } from 'devextreme/ui/form';
import { PdfViewUstVeriService } from './pdf-view-ust-veri.service';
import { CtlVgenBirimComponent } from '../../controls/ctl-vgen-birim/ctl-vgen-birim.component';
import { DysService } from 'libs/bys/src/lib/components/ortak/services/dys.service';

@Component({
  selector: 'dk-pdf-view-ust-veri',
  standalone: true,
  imports: [CommonModule, DxFileUploaderModule, DxLoadPanelModule, CtlIkaPersonelComponent, CtGenLookupComponent,PhoneComponent,
    CtlGenKisiComponent, CtlGenKontrolComponent, DxFormModule, DxButtonModule, CtlVgenBirimComponent],
  templateUrl: './pdf-view-ust-veri.component.html',
  styleUrls: ['./pdf-view-ust-veri.component.scss'],
})
export class PdfViewUstVeriComponent  implements OnInit{
  @Input() belgeKod:number;
  @Input() taslakKod:number;
  @Input() editMode = false;
  @Input() state = "Edit";
  @Input() gelenGiden:string;
  public labelMode:FormLabelMode = this.globalUserSettingsService.globalLabelMode;
  public labelLocation:LabelLocation = this.globalUserSettingsService.globalLabelLocation;
  bysBelge: BysBelge= new BysBelge({});
  bysBelgeDetay: BysBelgeDetay= new BysBelgeDetay({});
  isLoading=true;
  isReadOnly = true;
  isChange=true;
  initialFormData: BysBelge = new BysBelge();


  constructor(public service:PdfViewUstVeriService, private dysService: DysService,
    private utilService:UtilsService, private globalUserSettingsService: DkGlobalUserSettingsService){

  }

  ngOnInit(): void {
      this.service.getBysBelge(this.belgeKod).then((res)=>{
        this.bysBelge=res[0];
        if(!this.gelenGiden) this.gelenGiden = this.bysBelge.GelenGiden;
        this.initialFormData = structuredClone(this.bysBelge)
        this.isLoading=false;


      }).catch((err)=>this.utilService.showError(err));
      this.service.getBysBelgeDetay(this.belgeKod).then((res)=>{
        this.bysBelgeDetay=res[0];
      }).catch((err)=>this.utilService.showError(err));

  }

  ngOnChanges(changes: SimpleChanges): void {
      if(changes['taslakKod']){
        this.bysBelge.TaslakKod = this.taslakKod;
        this.initialFormData = structuredClone(this.bysBelge)
      }

      
  }

  eypIndirClick(){
    this.dysService.downloadSablonDoc(this.bysBelgeDetay?.EypDysId,this.bysBelgeDetay?.BelgeKod.toString()+'.eyp');
  }

  // getSpdResult($e: any) {

  //   if ($e == null||undefined) {
  //     this.bysBelge.BelgeTuruKod = null;
  //     this.bysBelge.DosyaPlanKod = null;
  //     this.bysBelge.BelgeTuru = null;
  //     this.DosyaPlanKodValid = false
  //   } else {
  //     if(this.bysBelge.DosyaPlanKod !== $e.DosyaPlanKod){
  //       this.service.getBelgeTuru($e.DosyaPlanKod).then((res)=>{
  //         this.bysBelge.BelgeTuruKod=res[0].Kod;
  //       }).catch((err)=>this.utilService.showError(err));
  //       this.bysBelge.DosyaPlanKod = $e.DosyaPlanKod;
  //       this.bysBelge.BelgeTuru = "E";
  //       this.getDosyaPlanKod.emit(this.bysBelge.DosyaPlanKod)
  //       this.DosyaPlanKodValid = true
  //     }
  //   }
  // }

  // getUstBilgiPersonel ($e: any) {
  //   if ($e == null||undefined) {
  //     this.bysBelge.PersonelKod = null;
  //     this.PersonelKodValid = false
  //   } else {
  //     this.bysBelge.PersonelKod = $e.Kod;
  //     this.PersonelKodValid = true
  //   }
  // }

  // getUstBilgiKisi($e: any)  {
  //   if ($e == null||undefined) {
  //     this.bysBelge.KisiKod = null;
  //     this.KisiKodValid = false
  //   } else {
  //     this.bysBelge.KisiKod = $e.Kod;
  //     this.KisiKodValid = true
  //   }
  // }

  // getUstBilgiBirim  ($e: any)  {
  //   if ($e == null||undefined) {
  //     this.bysBelge.BirimKod = null;
  //     this.bysBelge.GelenBirimAciklama = null;
  //     this.bysBelge.BilgiAdSoyad = null;
  //     this.bysBelge.BilgiUnvani = null;
  //     this.bysBelge.BilgiTelNo = null;
  //     this.bysBelge.BilgiEPosta = null;
  //     this.BirimKodValid = false
  //   } else {
  //     if(this.bysBelge.BirimKod !== $e.Kod){
  //     this.bysBelge.BirimKod = $e.Kod;
  //     this.bysBelge.GelenBirimAciklama = $e.Ad;
  //     this.bysBelge.BilgiAdSoyad = $e.YetkiliAdSoyad;
  //     this.bysBelge.BilgiUnvani = $e.YetkiliUnvani;
  //     this.bysBelge.BilgiTelNo = $e.YetkiliTelNo;
  //     this.bysBelge.BilgiEPosta = $e.BirimEPosta;
  //     this.BirimKodValid = true
  //     }
  //   }

  // }


  // AsliAlindiEhChanged = (e: any) => {
  //   this.bysBelge.AsliAlindiEh = e.value ? 'E' : 'H';
  // };

  // BilgiEdinmeEhChanged = (e: any) => {
  //   this.bysBelge.BilgiEdinmeEh = e.value ? 'E' : 'H';
  // };

  // TelifKapsamindaEhChanged = (e: any) => {
  //   this.bysBelge.TelifKapsamindaEh = e.value ? 'E' : 'H';
  // }
  
  // KisiselEhChanged = (e: any) => {
  //   this.bysBelge.KisiselEh = e.value ? 'E' : 'H';
  // }

  // DilekceEhChanged = (e: any) => {
  //   this.bysBelge.DilekceEh = e.value ? 'E' : 'H';
  // }
}

